export default __webpack_public_path__ + "static/media/investing-illustration.f7f959e1.svg";